import { DATA_REDUCERS } from './data';
import { PAGES_REDUCERS } from './pages';
import { STAGES_REDUCERS } from './stages';

export const REDUCERS = { ...DATA_REDUCERS, ...PAGES_REDUCERS, ...STAGES_REDUCERS };
